<template>

  <div style="overflow-y: auto;">
    <b-overlay :show="show" spinner-variant="primary" spinner-large rounded="sm" style="height:200vh" variant="dark"
      id="loader">
      <b-container fluid style="padding-top: 100px;text-align:left">
        <b-row>
          <b-col cols="12 headerF">
            <HeaderFixed />
          </b-col>
          <b-col cols="12 headerM">
            <HeaderMobile />
          </b-col>
        </b-row>
        <b-row>
          <b-col cols="12">
            <b-breadcrumb style=" background-color: #e9ecef78;">
              <b-breadcrumb-item href="#home">
                <router-link to="/">
                  <b-icon icon="house-door" scale="1.25" shift-v="1.25" aria-hidden="true"></b-icon>
                  Home
                </router-link>
              </b-breadcrumb-item>

              <b-breadcrumb-item href="#" active>Compliance of Sec 194Q</b-breadcrumb-item>
            </b-breadcrumb>
          </b-col>
        </b-row>
        <div>
          <b-card no-body>
            <b-tabs card fill>
              <b-tab title=" Update Tan Number " active>

                <div>

                  <b-row style="padding-top: 0px;">
                    <b-col col cols="5" sm="5" md="2" lg="2" style="padding-top: 7px;">
                      <span style="font-weight:600">Consumer No <span class="text-danger">*</span></span>
                    </b-col>
                    <b-col col cols="7" sm="7" md="3" lg="3" style="padding-top: 5px;">
                      <b-form-input type="text" maxlength="12" value="" id="consumerNumber"
                        placeholder="Enter Consumer Number" autocomplete="off" trim required />
                    </b-col>
                    <b-col col cols="5" sm="5" md="2" lg="2" style="padding-top: 5px;">
                      <img id="captcha" src="#" alt="captcha">
                      <a href="#" @click="generateCaptcha()"><b-icon icon="arrow-clockwise" font-scale="1.8"
                          style="padding-top:7px"></b-icon></a>

                    </b-col>
                    <b-col col cols="4" sm="4" md="2" lg="2" style="padding-top: 5px;">
                      <b-form-input type="number" id="result" placeholder="Answer" style="padding-top: 7px;" />
                    </b-col>
                    <b-col col cols="3" sm="3" md="3" lg="1" style="padding-top: 5px;">
                      <b-button @click="showDetails()" block pill variant="primary" size="md" class="go"
                        style="width:100%">
                        <b-icon icon="arrow-right-short" animation="" scale="1.8"> </b-icon>
                      </b-button>
                    </b-col>
                  </b-row>
                  <br>
                  <!-- </form> -->

                  <div id="UserDetails" class="userDetails marginRight30px">
                    <b-row>
                      <b-col cols=12>
                        <span class="heading">User Details</span>
                      </b-col>
                    </b-row>
                    <hr />
                    <br>
                    <!-- <form id="userRegistration"> -->
                    <b-row>
                      <b-col col cols="5" sm="2" md="2" lg="2">
                        <span class="label"> Consumer Name : </span>
                      </b-col>
                      <b-col col cols="7" sm="4" md="4" lg="3">
                        <span id="consName"></span>
                      </b-col>

                      <b-col col cols="5" sm="2" md="2" lg="2" class="marginTop10px">
                        <span class="label">Connection Type : </span>
                      </b-col>
                      <b-col col cols="7" sm="4" md="4" lg="3" class="marginTop10px">
                        <span id="connType"></span>

                      </b-col>
                    </b-row>
                    <br>
                    <b-row>
                      <b-col col cols="5" sm="2" md="2" lg="2">
                        <span class="label">Mobile No <span class="text-danger">*</span></span> :
                      </b-col>
                      <b-col col cols="7" sm="4" md="4" lg="3">
                        <!-- <b-form-input type="number"  id="mobNo" placeholder="Not Available" trim>
                        </b-form-input> -->
                        <span id="mobNo" style="display:block;"></span>
                        <span class="updateMobilestyle" style="display: none;">Mobile No. Not Registered</span>

                        <!--
                        <span>
                          <a @click="changeMobileNo()" style="color: #e64a19;cursor:pointer "
                            onmouseover="this.style.textDecoration='underline'; this.style.color='blue';"
                            onmouseout="this.style.textDecoration='none'; this.style.color='#e64a19 ';">
                            Change Mobile No
                          </a>
                        </span> -->
                      </b-col>
                      <b-col col cols="5" sm="2" md="2" lg="2" class="marginTop10px">
                        <span class="label">Email ID </span> :
                      </b-col>
                      <!-- <b-col col cols="7" sm="4" md="4" lg="3" class="marginTop10px">
                        <b-form-input type="email" id="email"  placeholder="Not Available" trim  >
                         </b-form-input> -->
                      <span id="email" style="display: block;"></span>
                      <span class="updateEmailstyle" style="display: none;">Not Available</span>
                      </b-col>

                    </b-row>
                    <br>
                    <b-row>
                      <b-col col cols="5" sm="2" md="2" lg="2">
                        <span class="label"> TAN Number <span class="text-danger">*</span></span> :
                      </b-col>
                      <b-col col cols="7" sm="4" md="4" lg="3">
                        <b-form-input type="text" maxlength="12" id="tan" placeholder="Enter TAN No" trim>
                        </b-form-input>
                      </b-col>
                      <b-col col cols="5" sm="2" md="2" lg="2">
                        <span class="label"> PAN No </span> :
                      </b-col>
                      <b-col col cols="7" sm="4" md="4" lg="3">
                        <b-form-input type="text" maxlength="12" id="pan" placeholder="Enter PAN No" trim>
                        </b-form-input>
                      </b-col>

                    </b-row>
                    <br>
                    <b-row>
                      <b-col col cols="12" sm="12" md="12" lg="12">
                        <b-form-checkbox id="checkbox-1" v-model="status1" name="checkbox-1" value="accepted"
                          unchecked-value="not_accepted">
                          We/I declare that Section 194Q of the Income Tax Act,1961 is applicable to us/me and
                          we/I have read and understood the provisions of this section and the related applicable rules,
                          notifications, circulars.
                        </b-form-checkbox>
                        <br>
                        <b-form-checkbox id="checkbox-2" v-model="status2" name="checkbox-2" value="accepted"
                          unchecked-value="not_accepted">
                          We/I confirm that we/I will submit /fill in the challan payment details on
                          monthly basis on APDCL's portal and will submit the quarterly tax deduction certificate to
                          the billing office of APDCL.
                        </b-form-checkbox>
                      </b-col>
                    </b-row>
                    <br>
                    <b-row>
                      <b-col col cols="12" sm="3" md="3" lg="3" offset-md="4" offset-lg="4">
                        <b-button block squared variant="primary" id="button" @click="sendOtp()">
                          Submit</b-button>
                        <br>
                      </b-col>
                      <b-col col cols="12" sm="3" md="3" lg="3" offset-md="2" offset-lg="2" id="ApdclPanBtn"
                        style="display:none">
                        <router-link to="/ApdclPanDetails">
                          <b-button block squared variant="outline-primary">
                            Print APDCL ITR Details
                          </b-button>
                        </router-link>
                        <br>
                      </b-col>
                    </b-row>
                    <!-- </form> -->

                  </div>

                </div>

              </b-tab>
              <b-tab title="TDS Upload">
                <div>

                  <b-row style="padding-top: 0px;">
                    <b-col col cols="5" sm="5" md="2" lg="2" style="padding-top: 7px;">
                      <span style="font-weight:600">Consumer No <span class="text-danger">*</span></span>
                    </b-col>
                    <b-col col cols="7" sm="7" md="3" lg="3" style="padding-top: 5px;">
                      <b-form-input type="text" maxlength="12" value="" id="consumerNumber2"
                        placeholder="Enter Consumer Number" autocomplete="off" trim required />
                    </b-col>
                    <b-col col cols="5" sm="5" md="2" lg="2" style="padding-top: 5px;">
                      <img id="captcha2" src="#" alt="captcha">
                      <a href="#" @click="generateCaptcha()"><b-icon icon="arrow-clockwise" font-scale="1.8"
                          style="padding-top:7px"></b-icon></a>
                    </b-col>
                    <b-col col cols="4" sm="4" md="2" lg="2" style="padding-top: 5px;">
                      <b-form-input type="number" id="result2" placeholder="Answer" style="padding-top: 7px;" />
                    </b-col>
                    <b-col col cols="3" sm="3" md="3" lg="1" style="padding-top: 5px;">
                      <b-button @click="showDetails2()" block pill variant="primary" size="md" class="go"
                        style="width:100%">
                        <b-icon icon="arrow-right-short" animation="" scale="1.8"> </b-icon>
                      </b-button>
                    </b-col>
                  </b-row>
                  <br>
                  <!-- </form> -->

                  <div id="UserDetails2" class="userDetails marginRight30px">
                    <b-row>
                      <b-col cols=12>
                        <span class="heading">User Details</span>
                      </b-col>
                    </b-row>
                    <hr />
                    <br>
                    <!-- <form id="userRegistration"> -->
                    <b-row>
                      <b-col col cols="5" sm="2" md="2" lg="2">
                        <span class="label"> Consumer Name : </span>
                      </b-col>
                      <b-col col cols="7" sm="4" md="4" lg="3">
                        <span id="consName2"></span>
                      </b-col>

                      <b-col col cols="5" sm="2" md="2" lg="2" class="marginTop10px">
                        <span class="label">Tan Number : </span>
                      </b-col>
                      <b-col col cols="7" sm="4" md="4" lg="3" class="marginTop10px">
                        <span id="tan2"></span>
                        <br>
                        <span>
                          <a @click="reloadPage()" style="color: #0277bd ;cursor:pointer "
                            onmouseover="this.style.textDecoration='underline'; this.style.color='e64a19';"
                            onmouseout="this.style.textDecoration='none'; this.style.color='#0277bd ';">
                            Click here to Update TAN No.
                          </a>
                        </span>

                      </b-col>
                    </b-row>
                    <br>

                    <div id="tdsEntry">
                      <b-row>
                        <b-col col cols="5" sm="2" md="2" lg="2">
                          <span class="label">Bill No <span class="text-danger">*</span></span> :
                        </b-col>
                        <b-col col cols="7" sm="4" md="4" lg="3">
                          <b-form-select id="billNo" v-model="billNoSelected" :options="options"></b-form-select>
                          <!--
                      <span>
                        <a @click="changeMobileNo()" style="color: #e64a19;cursor:pointer "
                          onmouseover="this.style.textDecoration='underline'; this.style.color='blue';"
                          onmouseout="this.style.textDecoration='none'; this.style.color='#e64a19 ';">
                          Change Mobile No
                        </a>
                      </span>
                     -->
                        </b-col>
                        <b-col col cols="5" sm="2" md="2" lg="2" class="marginTop10px">
                          <span class="label">TDS Deducted </span> :
                        </b-col>
                        <b-col col cols="7" sm="4" md="4" lg="3" class="marginTop10px">
                          <b-form-input type="number" id="tdsDeducted" v-model="TdsAmount"
                            placeholder="Enter TDS Deducted " @keyup="numToWord()">
                          </b-form-input>
                        </b-col>
                        <b-col col cols="12" sm="12" md="1" lg="1" @click="$bvModal.show('showAmount')">
                          <b-form-checkbox id="checkbox-4" v-model="verify1" name="checkbox-4" value="verified"
                            unchecked-value="not_verified">
                            Verify
                          </b-form-checkbox>
                        </b-col>
                      </b-row>
                      <br>
                      <b-row>
                        <b-col col cols="5" sm="2" md="2" lg="2" offset-lg="5" class="marginTop10px">
                          <span class="label">In Words </span> :
                        </b-col>
                        <b-col col cols="7" sm="4" md="4" lg="3" class="marginTop10px"
                          style="border-bottom:1px solid black;">
                          <span id="tdsDeductedWord" style="color:#ff7043;"> </span>

                        </b-col>
                        <b-col col cols="12" sm="12" md="1" lg="1" @click="$bvModal.show('showAmount')">
                          <b-form-checkbox id="checkbox-5" v-model="verify2" name="checkbox-5" value="verified"
                            unchecked-value="not_verified">
                            Verify
                          </b-form-checkbox>
                        </b-col>
                      </b-row>

                      <br>
                      <b-row>
                        <b-col col cols="5" sm="2" md="2" lg="2">
                          <span class="label"> Challan No. <span class="text-danger">*</span></span> :
                        </b-col>
                        <b-col col cols="7" sm="4" md="4" lg="3">
                          <b-form-input type="text" id="challanNo" v-model="challanNo" placeholder="Enter Challan No."
                            trim>
                          </b-form-input>
                        </b-col>
                        <b-col col cols="5" sm="2" md="2" lg="2">
                          <span class="label"> Challan Date </span> :
                        </b-col>
                        <b-col col cols="7" sm="4" md="4" lg="3">

                          <b-form-datepicker id="datepicker" v-model="challanDate" class="mb-2"></b-form-datepicker>
                          <!-- <p>Value: '{{ challanDate }}'</p> -->
                        </b-col>

                      </b-row>
                      <br>
                      <b-row>
                        <b-col col cols="5" sm="2" md="2" lg="2">
                          <span class="label"> Challan Amount <span class="text-danger">*</span></span> :
                        </b-col>
                        <b-col col cols="7" sm="4" md="4" lg="3">
                          <b-form-input type="number" id="challanAmt" v-model="challanAmt"
                            placeholder="Enter Challan Amount">
                          </b-form-input>
                        </b-col>
                        <b-col col cols="5" sm="2" md="2" lg="2">
                          <span class="label"> Upload Challan </span> :
                        </b-col>
                        <b-col col cols="7" sm="4" md="4" lg="3">
                          <b-form-file plain id="challanToUpload"></b-form-file>
                          <span id="challanAlreadyUploaded" style="color:#0277bd;display:none"> Challan Already Uploaded
                            for this TAN No</span>
                        </b-col>

                      </b-row>
                      <br>
                      <b-row>
                        <b-col col cols="12" sm="12" md="12" lg="12">
                          <b-form-checkbox id="checkbox-3" v-model="status3" name="checkbox-3" value="accepted"
                            unchecked-value="not_accepted">
                            <div style="text-align:justify"> I <input type="text" id="authorizedPerson"
                                v-model="authName" placeholder="" style="border: 0;border-bottom: 1px solid black;"
                                class="declaration"> </input>

                              , the authorized person on behalf of <span class="declaration">{{ consName }} </span>
                              having Consumer Number
                              <span class="declaration">{{ consNo }} </span>
                              do hereby undertake and submit that an amount of Rs <span class="declaration">{{ TdsAmount
                                }} ({{ TdsAmountWord }})</span> has been
                              deducted as TDS as per the provisions of Section 194Q of Income Tax Act, 1961
                              from the electricity bill vide Invoice No. <span class="declaration">{{ billNoSelected }}
                              </span> dated <span class="declaration">{{ billDate }} </span>
                              and same was deposited to concerned authorities vide Challan No. <span
                                class="declaration">{{ challanNo }} </span> dated
                              <span class="declaration">{{ challanDate }}</span>.

                              If at any point of time, it is found that the declaration above is false in any aspect,
                              I <span class="declaration">{{ authName }} </span> as well as <span class="declaration">{{
                                consName}} </span> having Consumer account No.
                              <span class="declaration">{{ consNo }} </span>
                              will be responsible and APDCL can take any legal recourse upto and including
                              attachment of assets to the extent as deem fit by APDCL.

                              I <span class="declaration">{{ authName }} </span>, the authorized person on behalf of
                              <span class="declaration">{{ consName }} </span>
                              having Consumer Account No. <span class="declaration">{{ consNo }} </span> also
                              do hereby undertake that neither me nor <span class="declaration">{{ consName }} </span>
                              will challange the decision of APDCL in any court of Law at any point of time.

                              I <span class="declaration">{{ authName }}</span>, the authorized person on behalf of <span
                                class="declaration">{{ consName }} </span>
                              having Consumer Account No.<span class="declaration">{{ consNo }} </span> also do hereby
                              undertake that this online
                              submission can be treated as a legal evidence under The Indian Evidence Act, 1872 in any
                              legal proceedings.”
                            </div>
                          </b-form-checkbox>

                        </b-col>
                      </b-row>
                      <br>
                      <b-row>
                        <b-col col cols="12" sm="3" md="3" lg="3" offset-md="4" offset-lg="4">
                          <b-button block squared variant="primary" id="button" @click="tdsDetailsUpdate()">
                            Submit</b-button>
                          <br>
                        </b-col>

                      </b-row>
                      <!-- </form> -->
                    </div>
                  </div>

                </div>
              </b-tab>
            </b-tabs>
          </b-card>
        </div>

      </b-container>
      <br>


      <b-modal id="otpModal" centered no-close-on-esc no-close-on-backdrop title="OTP Verification" hide-footer>
        <b-overlay :show="show1" spinner-variant="primary" spinner-large rounded="sm" style="" variant="dark"
          id="loader">
          Enter the OTP received in your mobile number :
          <b-form-input type="number" id="otp"></b-form-input><br>
          <b-button class="btn" variant="primary" id="success-btn" @click="tanUpdate()">Verify</b-button> &nbsp&nbsp
          <b-button class="btn" variant="outline-primary" id="success-btn" @click="resendOtp()">Resend OTP</b-button>
        </b-overlay>
      </b-modal>


      <b-modal id="showAmount" centered no-close-on-esc no-close-on-backdrop scrollable hide-footer hide-header lazy>
        <h3>You have entered </h3>
        <br>
        Amount: <span style="color:#ff5722;font-weight:600">
          Rs. {{ TdsAmount }}
        </span>
        <br>
        In Words: <span style="color:#ff5722;font-weight:600 "> {{ TdsAmountWord }}</span>
        <br>
        <br>
        <p>
          <b-button class="btn btn-outline" variant="primary" @click="closeModal('showAmount')">Confirm</b-button>
          <!-- <b-button class="btn btn-outline" variant="danger" @click="closeModal('showAmount')">Edit</b-button> -->
        </p>
      </b-modal>


      <b-modal id="successModal" centered no-close-on-esc no-close-on-backdrop scrollable hide-footer hide-header>
        <h3>Consumer TAN No Update</h3>
        <svg class="modalFont" version="1.1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 130.2 130.2">
          <circle class="path circle" fill="none" stroke="#73AF55" stroke-width="6" stroke-miterlimit="10" cx="65.1"
            cy="65.1" r="62.1" />
          <polyline class="path check" fill="none" stroke="#73AF55" stroke-width="6" stroke-linecap="round"
            stroke-miterlimit="10" points="100.2,40.2 51.5,88.8 29.8,67.5 " />
        </svg>
        <p class="success">Successfully Updated !<br><br>
          <router-link to="/ApdclPanDetails">
            <b-button class="btn btn-outline" variant="success">OK</b-button>
          </router-link>

        </p>
      </b-modal>
      <b-modal id="successModal2" centered no-close-on-esc no-close-on-backdrop scrollable hide-footer hide-header>
        <h3>TDS Upload</h3>
        <svg class="modalFont" version="1.1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 130.2 130.2">
          <circle class="path circle" fill="none" stroke="#73AF55" stroke-width="6" stroke-miterlimit="10" cx="65.1"
            cy="65.1" r="62.1" />
          <polyline class="path check" fill="none" stroke="#73AF55" stroke-width="6" stroke-linecap="round"
            stroke-miterlimit="10" points="100.2,40.2 51.5,88.8 29.8,67.5 " />
        </svg>
        <p class="success">Successfully Updated !<br><br>

          <b-button class="btn btn-outline" variant="success" @click="reloadPage()">OK</b-button>


        </p>
      </b-modal>

      <b-modal id="failureModal" centered lazy scrollable title="Consumer TAN No Update" hide-footer>
        <svg class="modalFont" version="1.1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 130.2 130.2">
          <circle class="path circle" fill="none" stroke="#D06079" stroke-width="6" stroke-miterlimit="10" cx="65.1"
            cy="65.1" r="62.1" />
          <line class="path line" fill="none" stroke="#D06079" stroke-width="6" stroke-linecap="round"
            stroke-miterlimit="10" x1="34.4" y1="37.9" x2="95.8" y2="92.3" />
          <line class="path line" fill="none" stroke="#D06079" stroke-width="6" stroke-linecap="round"
            stroke-miterlimit="10" x1="95.8" y1="38" x2="34.4" y2="92.2" />
        </svg>
        <p class="error">Update Failed ! </p>
      </b-modal>
      <b-modal id="failureModal2" centered lazy scrollable title="TDS Upload" hide-footer>
        <svg class="modalFont" version="1.1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 130.2 130.2">
          <circle class="path circle" fill="none" stroke="#D06079" stroke-width="6" stroke-miterlimit="10" cx="65.1"
            cy="65.1" r="62.1" />
          <line class="path line" fill="none" stroke="#D06079" stroke-width="6" stroke-linecap="round"
            stroke-miterlimit="10" x1="34.4" y1="37.9" x2="95.8" y2="92.3" />
          <line class="path line" fill="none" stroke="#D06079" stroke-width="6" stroke-linecap="round"
            stroke-miterlimit="10" x1="95.8" y1="38" x2="34.4" y2="92.2" />
        </svg>
        <p class="error">Update Failed or TDS Already Uploaded </p>
      </b-modal>

      <b-modal id="model" centered scrollable title="ALERT !" :static="true" hide-footer>
        <span class="data" id="modalMsg"> </span>
        <br><br>
        <b-button style="width:8rem" variant="outline-primary" @click="closeModal('model')">OK</b-button>
      </b-modal>
      <b-modal id="smartConsModal" centered lazy scrollable title="Consumer Status" hide-footer>
        <svg class="modalFont" version="1.1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 130.2 130.2">
          <circle class="path circle" fill="none" stroke="#D06079" stroke-width="6" stroke-miterlimit="10" cx="65.1"
            cy="65.1" r="62.1" />
          <line class="path line" fill="none" stroke="#D06079" stroke-width="6" stroke-linecap="round"
            stroke-miterlimit="10" x1="34.4" y1="37.9" x2="95.8" y2="92.3" />
          <line class="path line" fill="none" stroke="#D06079" stroke-width="6" stroke-linecap="round"
            stroke-miterlimit="10" x1="95.8" y1="38" x2="34.4" y2="92.2" />
        </svg>
        <p class="error">TDS can not be uploaded for Smart Consumer</p>
        <div class="d-flex justify-content-center">
          <b-button class="btn btn-outline" variant="danger" @click="reloadPage()">OK</b-button>
        </div>
      </b-modal>
    </b-overlay>
  </div>

</template>


<script>
import axios from 'axios';
import HeaderFixed from '@/components/HeaderFixed.vue'
import HeaderMobile from '@/components/HeaderMobile.vue'
const numWords = require('num-words');

var consNo = "";
var oldMob = "";
var email = "";
var tan = "";
var pan = "";
var dataToSend;

export default {
  name: 'ConsReg',
  components: {

    'HeaderFixed': HeaderFixed,
    'HeaderMobile': HeaderMobile
    //MarqueeText

  },
  computed: {

  },
  data() {
    return {
      value: '',
      show: false,
      show1: false,
      show2: false,
      consNumber: "",
      status1: 'not_accepted',
      status2: 'not_accepted',
      status3: 'not_accepted',
      verify1: 'not_verified',
      verify2: 'not_verified',
      billNoSelected: null,
      options: [

      ],
      TdsAmount: '',
      TdsAmountWord: '',
      consName: '',
      consNo: '',
      billNo: '',
      billDate: '',
      challanNo: '',
      challanDate: '',
      challanAmt: '',
      authName: '',
      tanNo: '',


    }
  },
  methods: {
    reloadPage() {
      window.location.reload();
    },
    generateCaptcha() {
      axios.post(this.$urlCommon + "/api/web/getCaptcha").then(function (response) {
        //// console.log(response.data);
        document.getElementById("captcha").src = "data:image/png;base64," + response.data;
        document.getElementById("captcha2").src = "data:image/png;base64," + response.data;


      })
    },

    showDetails() {
      consNo = document.getElementById("consumerNumber").value;
      this.consNumber = consNo;
      var result = document.getElementById("result").value;

      if ((consNo.toString().length != 12)) {
        this.$bvToast.toast('Enter 12 Digit Consumer Number !', {
          title: `Alert`,
          variant: 'danger',
          solid: true
        })
        document.getElementById("consumerNumber").focus();
        return;
      }

      if ((result == "")) {
        this.$bvToast.toast('Enter Captcha Answer !', {
          title: `Alert`,
          variant: 'danger',
          solid: true
        })
        return;
      }
      var parent = this;
      this.show = true;
      // axios.post(this.$urlArms+'/RestAPI/myBijulee/ConsDetails?cons_no='+consNo)
      axios.get(this.$urlCommon + '/api/web/updateTanNo/getConsDetails?consNo=' + consNo + "&result=" + result)
        .then((response) => {
          parent.show = false;
          document.getElementById("UserDetails").classList.add("showUserDetails");

          // console.log("user details:::::::" + response.data);
          var data = response.data;
          var status = data.message;


          if (status == "00") {
            parent.generateCaptcha();
            document.getElementById("consName").innerHTML = data.cons_name;
            document.getElementById("connType").innerHTML = data.connType;
            document.getElementById("mobNo").innerHTML = data.mobile_no;
            oldMob = data.mobile_no;
            // console.log("data.mobile_data::::::::" + oldMob);
            if (data.mobile_no === "") {
              document.querySelector(".updateMobilestyle").style.display = 'block';
            } else {
              document.querySelector(".updateMobilestyle").style.display = 'none';
            }
            email = data.email
            if (email === "") {
              let element = document.querySelector(".updateEmailstyle");
              if (element) {
                element.style.display = 'block';
              } else {
                console.error("Element with class 'updateEmailstyle' not found");
              }
            } else {
              let element = document.querySelector(".updateEmailstyle");
              if (element) {
                element.style.display = 'none';
                document.getElementById("email").style.display = 'block';
              } else {
                console.error("Element with class 'updateEmailstyle' not found");
              }
            }
            document.getElementById("email").value = data.email;
            document.getElementById("tan").value = data.tan_NO;
            document.getElementById("pan").value = data.pan_NO;
            // console.log(data.tan_NO.length);
            if (data.tan_NO.length > 0)
              document.getElementById("ApdclPanBtn").style.display = "block";

          }
          else if (status == "captcha_incorrect") {
            parent.$bvToast.toast('Invalid Captcha ! Please try again', {
              title: `Alert`,
              variant: 'danger',
              solid: true
            });
            document.getElementById("UserDetails").classList.remove("showUserDetails");
            parent.generateCaptcha();
          }
          else {
            parent.show = false;
            parent.$bvModal.show('model');
            document.getElementById("modalMsg").innerHTML = "Sorry, Consumenr Not Found";
            document.getElementById("UserDetails").classList.remove("showUserDetails");
          }

        })
        .catch((e) => {
          // console.log("Caught", e);
          this.show = false;
        })

    },
    showDetails2() {
      var consNo = document.getElementById("consumerNumber2").value;
      this.consNumber = consNo;

      // Validate consumer number
      if (consNo.toString().length != 12) {
        this.$bvToast.toast('Enter 12 Digit Consumer Number !', {
          title: `Alert`,
          variant: 'danger',
          solid: true
        });
        return;
      }

      // Validate captcha
      var result = document.getElementById("result2").value;
      if (result == "") {
        this.$bvToast.toast('Enter Captcha !', {
          title: `Alert`,
          variant: 'danger',
          solid: true
        });
        return;
      }

      var parent = this;
      this.show = true;

      axios.get(this.$urlCommon + '/api/web/TdsUpload/getConsDetails?consNo=' + consNo + "&result=" + result)
        .then((response) => {

          parent.show = false;

          if (response.data.status == "success") {

            // Smart prepaid check
            if (response.data.consType == 'Smart_Prepaid') {
              parent.$bvModal.show('smartConsModal');
              return;
            }

            document.getElementById("UserDetails2").classList.add("showUserDetails");

            var data = response.data;

            // Assign values
            document.getElementById("consName2").innerHTML = data.consName;
            document.getElementById("tan2").innerHTML = data.tanNo;

            parent.consName = data.consName;
            parent.consNo = data.consNo;
            parent.tanNo = data.tanNo;

            // TAN check
            if (data.tanNo == "") {
              document.getElementById("tan2").innerHTML = "TAN Number Not Available";
              document.getElementById("tan2").style.color = "red";
              document.getElementById("tdsEntry").style.display = "none";
              return;
            }

            // Reset dropdown
            this.options = [];
            this.options.push({ value: null, text: 'Please Select Bill No' });

            // No bill case
            if (data.billList.length == 2) {
              parent.$bvModal.show('model');
              document.getElementById("modalMsg").innerHTML = "Sorry, Bill Not Found";
              document.getElementById("UserDetails2").classList.remove("showUserDetails");
              return;
            }

            // Process bill list
            var billStr = data.billList.substring(1, data.billList.length - 1);
            var billArr = billStr.split(",");

            var monthNames = [
              "January", "February", "March", "April", "May", "June",
              "July", "August", "September", "October", "November", "December"
            ];

            var today = new Date();
            var currentMonth = today.getMonth();
            var currentYear = today.getFullYear();

            var lastMonth = currentMonth - 1;
            var lastMonthYear = currentYear;

            // Fix January edge case
            if (lastMonth < 0) {
              lastMonth = 11;
              lastMonthYear--;
            }

            for (var i = 0; i < billArr.length; i++) {

              var parts = billArr[i].trim().split("##");  // .trim()

              // Safety check
              if (parts.length < 2) continue;

              var billNo = parts[0];
              var billDate = new Date(parts[1]);

              var billMonth = billDate.getMonth();
              var billYear = billDate.getFullYear();

              var isCurrent = (billMonth == currentMonth && billYear == currentYear);
              var isLast = (billMonth == lastMonth && billYear == lastMonthYear);

              // Only current + last month
              if (isCurrent || isLast) {
                this.options.push({
                  value: billNo,
                  text: billNo
                });
              }
            }

            // If no valid bills found
            if (this.options.length === 1) {
              parent.$bvModal.show('model');
              document.getElementById("modalMsg").innerHTML =
                "No bill available for " +
                monthNames[lastMonth] + " " + lastMonthYear +
                " or " +
                monthNames[currentMonth] + " " + currentYear + ".";
              document.getElementById("UserDetails2").classList.remove("showUserDetails");
            }

          }

          // Captcha incorrect
          else if (response.data.message == "captcha_incorrect") {
            parent.$bvToast.toast('Invalid Captcha ! Please try again', {
              title: `Alert`,
              variant: 'danger',
              solid: true
            });
            document.getElementById("UserDetails2").classList.remove("showUserDetails");
            parent.generateCaptcha();
          }

          // Consumer not found
          else {
            parent.$bvModal.show('model');
            document.getElementById("modalMsg").innerHTML = "Consumer not Found";
            document.getElementById("UserDetails2").classList.remove("showUserDetails");
          }

        })
        .catch((e) => {
          // console.log("Caught", e);
          parent.$bvModal.show('model');
          document.getElementById("modalMsg").innerHTML = "Sorry, Consumer/Bill Not Found";
          document.getElementById("UserDetails2").classList.remove("showUserDetails");
          this.show = false;
        });
    },
    changeMobileNo() {
      document.getElementById("mobNo").value = "";
      document.getElementById("mobNo").focus();
    },
    sendOtp() {
      var parent = this;
      var mobile = document.getElementById("mobNo").innerHTML;
      // // console.log("Sendotp mobile:::::"+mobile);
      email = document.getElementById("email").value;
      tan = document.getElementById("tan").value;
      pan = document.getElementById("pan").value;
      var consNo = document.getElementById("consumerNumber").value;
      // // console.log("send otp cons no::::::"+consNo)
      // // console.log(tan+"#####"+pan);

      var mobregx = /^[5-9]\d{9}$/
      if (mobile == ' ') {
        this.$bvToast.toast('Your account is not linked with any mobile number. Please visit your sub-division office to update your mobile number.', {
          title: `Alert`,
          variant: 'danger',
          solid: true
        })
        document.getElementById("mobNo").focus();
        return
      }
      // else if(!mobregx.test(mobile))
      //   {

      //     this.$bvToast.toast('Registered Mobile Number is not a 10 Digit Valid Mobile Number !', {
      //       title: `Alert`,
      //       variant: 'danger',
      //       solid: true
      //     })
      //     document.getElementById("mobNo").focus();
      //   return
      //   }

      // var emailRegex = /^(([^<>()[\]\.,;:\s@\"]+(\.[^<>()[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i;
      // if(!emailRegex.test(email) && email!="")
      //   {
      //     // document.getElementById('failure-btn-mob').click();
      //     this.$bvToast.toast('Enter Valid Email !', {
      //       title: `Alert`,
      //       variant: 'danger',
      //       solid: true
      //     })
      //     document.getElementById("email").focus();
      //   return
      //   }

      var tanRegex = /^([a-zA-Z]){4}([0-9]){5}([a-zA-Z]){1}?$/;
      if (!tanRegex.test(tan) && tan != "UPDATED") {
        // document.getElementById('failure-btn-mob').click();
        this.$bvToast.toast('Enter Valid TAN Number !', {
          title: `Alert`,
          variant: 'danger',
          solid: true
        })
        document.getElementById("tan").focus();
        return
      }


      var panRegex = /(^([a-zA-Z]{5})([0-9]{4})([a-zA-Z]{1})$)/;
      if (!panRegex.test(pan) && pan != "" && pan != "UPDATED") {
        // document.getElementById('failure-btn-mob').click();
        this.$bvToast.toast('Enter Valid PAN Number !', {
          title: `Alert`,
          variant: 'danger',
          solid: true
        })
        document.getElementById("pan").focus();
        return
      }
      if (this.status1 === "not_accepted") {
        // document.getElementById('failure-btn-mob').click();
        this.$bvToast.toast('Please Accept Declaration !', {
          title: `Alert`,
          variant: 'danger',
          solid: true
        })
        document.getElementById("checkbox-1").focus();
        return
      }
      if (this.status2 === "not_accepted") {
        // document.getElementById('failure-btn-mob').click();
        this.$bvToast.toast('Please Accept Declaration !', {
          title: `Alert`,
          variant: 'danger',
          solid: true
        })
        document.getElementById("checkbox-2").focus();
        return
      }
      dataToSend = {
        cons_no: consNo,
        tan_no: tan,
        pan_no: pan,
        declaration_1: this.status1,
        declaration_2: this.status2
      }
      // // console.log("data to send:::::"+JSON.stringify(dataToSend));


      parent.show = true;
      // axios.post(parent.$urlCommon+"/api/generateOtp?mobNo="+mobile).then(function(response) {
      axios.post(parent.$urlCommon + "/api/otp/sendConsumerOTP?consNo=" + consNo).then(function (response) {
        // // console.log("OTP response::::"+JSON.stringify(response.data));
        parent.show = false;
        if (response.data.msg == "success") {
          parent.$bvToast.toast('OTP Sent Successfully !', {
            title: `Success`,
            variant: 'success',
            solid: true
          });
          parent.$bvModal.show('otpModal');
        }
      });

    },

    closeModal(modalId) {
      this.$bvModal.hide(modalId)
    },
    resendOtp() {
      var parent = this;
      // var mobile = document.getElementById("mobNo").value;
      var consNo = document.getElementById("consNo").value;
      parent.show1 = true;
      // axios.post(this.$urlCommon+"/api/reGenerateOtp?mobNo="+mobile).then(function(response) {
      axios.post(this.$urlCommon + "/api/otp/SendConsumerOTP?consNo=" + consNo + "&type=resend").then(function (response) {
        parent.show1 = false;
        if (response.data.message == "success") {
          parent.$bvToast.toast('OTP Sent Successfully !', {
            title: `Success`,
            variant: 'success',
            solid: true
          });
        }
        else {
          parent.$bvToast.toast('OTP Could not Sent !', {
            title: `danger`,
            variant: 'danger',
            solid: true
          });
        }
      });
    },

    tanUpdate() {
      var otp = document.getElementById("otp").value;
      // var mobile = document.getElementById("mobNo").value;
      var parent = this;

      // var mobregx = /^[5-9]\d{9}$/
      // if(!mobregx.test(mobile))
      // {

      //   this.$bvToast.toast('Enter 10 Digit Valid Mobile Number !', {
      //     title: `Alert`,
      //     variant: 'danger',
      //     solid: true
      //   })
      // return;
      // }


      if (otp == "") {

        this.$bvToast.toast('Enter OTP !', {
          title: `Alert`,
          variant: 'danger',
          solid: true
        })
        return;
      }

      parent.show1 = true;
      // axios.post(parent.$urlCommon+"/api/validateOtp?mobNo="+mobile+"&otpNo="+otp).then(function(response)
      // {
      //   // console.log(response.data);

      //   if (response.data.message == "VALID") {

      //       parent.$bvToast.toast('OTP Successfully Verified !', {
      //       title: `Success`,
      //       variant: 'success',
      //       solid: true
      //     });

      //          axios.post(parent.$urlCommon+"/myBijulee/updateTanDetails?mobNo="+mobile+"&email="+email,dataToSend).then(function(response) {
      // axios.post(parent.$urlCommon+"/myBijulee/updateTanDetails?mobNo="+mobile+"&email="+email+"&otpNo="+otp,dataToSend).then(function(response) {
      axios.post(parent.$urlCommon + "/api/web/updateTanNo/update?otpNo=" + otp, dataToSend).then(function (response) {
        // console.log(JSON.stringify(response.data));
        parent.show1 = false;
        parent.show = false;
        var msg = response.data.msg;
        if (msg == "00") {

          parent.$bvModal.show('successModal');
        }
        else {

          parent.$bvModal.show('failureModal');
        }
      })
        .catch((e) => {
          parent.show = false;
          parent.$bvModal.show('model');
          document.getElementById("modalMsg").innerHTML = "Sorry, Please Try Again Later";
          // console.log("Caught :::::::::::::::", e.message);
        })
      // }
      // else{
      //   parent.show1= false;
      //   parent.$bvModal.show('model');
      //   document.getElementById("modalMsg").innerHTML="Invalid OTP";
      // }

      // });

    },

    numToWord() {

      var num = document.getElementById("tdsDeducted").value;
      const amountInWords = numWords(num);
      document.getElementById("tdsDeductedWord").innerHTML = amountInWords;
      //  document.getElementById("TdsAmountWordHidden").value=amountInWords;
      this.TdsAmountWord = amountInWords;
      //  // console.log("Amt:"+amountInWords);
    },

    tdsDetailsUpdate() {
      var parent = this;

      if (this.billNoSelected == null) {
        this.$bvToast.toast('Select a Bill Number !', {
          title: `Error`,
          variant: 'danger',
          solid: true
        });
        document.getElementById("billNo").focus();
        return;
      }

      if (this.TdsAmount == '') {
        this.$bvToast.toast('Enter TDS Deducted Amount !', {
          title: `Error`,
          variant: 'danger',
          solid: true
        });
        document.getElementById("tdsDeducted").focus();
        return;
      }
      if (this.verify1 == 'not_verified') {
        this.$bvToast.toast('Please Verify the Entered Amount !', {
          title: `Error`,
          variant: 'danger',
          solid: true
        });
        document.getElementById("checkbox-4").focus();
        return;
      }
      if (this.verify2 == 'not_verified') {
        this.$bvToast.toast('Please Verify the Entered Amount !', {
          title: `Error`,
          variant: 'danger',
          solid: true
        });
        document.getElementById("checkbox-5").focus();
        return;
      }
      if (this.challanNo == '') {
        this.$bvToast.toast('Please Enter Challan Number !', {
          title: `Error`,
          variant: 'danger',
          solid: true
        });
        document.getElementById("challanNo").focus();
        return;
      }
      if (this.challanDate == '') {
        this.$bvToast.toast('Please Enter Challan Date !', {
          title: `Error`,
          variant: 'danger',
          solid: true
        });
        document.getElementById("challanDate").focus();
        return;
      }
      if (this.challanAmt == '') {
        this.$bvToast.toast('Please Enter Challan Amount !', {
          title: `Error`,
          variant: 'danger',
          solid: true
        });
        document.getElementById("challanAmt").focus();
        return;
      }

      if (this.authName == '') {
        this.$bvToast.toast('Please Enter Authorized Person Name !', {
          title: `Error`,
          variant: 'danger',
          solid: true
        });
        document.getElementById("authorizedPerson").focus();
        return;
      }
      if (this.status3 == 'not_accepted') {
        this.$bvToast.toast('Please check Declaration !', {
          title: `Error`,
          variant: 'danger',
          solid: true
        });
        document.getElementById("checkbox-3").focus();
        return;
      }

      var consNo = document.getElementById("consumerNumber2").value;
      var cKey = {};
      cKey['cons_no'] = document.getElementById("consumerNumber2").value;
      cKey['bill_no'] = this.billNoSelected;

      var tdsDataToSend = {
        tdsDetailsDatamodelCompositeId: cKey,
        tan_no: this.tanNo,
        tds_deducted: this.TdsAmount,
        challan_no: this.challanNo,
        challan_date: this.challanDate,
        challan_amt: this.challanAmt,
        tds_verification: this.verify1,
        file_uploaded: 'Y',
        declaration: this.status3

      }

      // console.log(tdsDataToSend);



      var formData = new FormData();
      var file = document.querySelector('#challanToUpload');

      var fileExt = file.files[0].name.split('.').pop();
      // console.log("file  " + fileExt);
      if (fileExt != "pdf") {
        this.$bvToast.toast('Only PDF file is allowed !', {
          title: `Error`,
          variant: 'danger',
          solid: true
        });
        document.getElementById("challanToUpload").focus();
        return;
      }
      //formData.append("uploadfile", "/path/dd");
      //  formData.append("uploadfile", file.files[0]);
      formData.append("uploadfile", file.files[0]);

      parent.show = true;
      // axios.post(parent.$urlArms+"/RestAPI/OnlinePortal/updateTdsConsDetails?consNo="+consNo+"&tanNo="+tdsDataToSend.tan_no+"&billNo="+this.billNoSelected+"&tdsAmountDeducted="+tdsDataToSend.tds_deducted+"&challanNo="+tdsDataToSend.challan_no+"&challanDt="+tdsDataToSend.challan_date+"&challanAmt="+tdsDataToSend.challan_amt+"&authorisedPerson="+this.authName,formData,{
      //     headers: {
      //       'Content-Type': 'multipart/form-data'
      //     }
      // }).then(function(response) {
      // // console.log(response.data);

      // var msg=response.data.status;
      // if(msg=="Success") {

      //   axios.post(parent.$urlCommon+"/api/web/updateTdsDetails",tdsDataToSend).then(function(response) {
      //   //   axios.post("http://localhost:8081/website"+"/api/web/updateTdsDetails",tdsDataToSend).then(function(response) {
      //      // console.log(response.data);
      //        parent.show= false;
      //      var msg=response.data.msg;
      //      if(msg=="00") {

      //        parent.$bvModal.show('successModal2');
      //      }
      //      else
      //      {
      //        parent.$bvModal.show('failureModal2');
      //      }
      //      })
      //      .catch((e) => {
      //        parent.show= false;
      //        parent.$bvModal.show('model');
      //        document.getElementById("modalMsg").innerHTML="Sorry, Please Try Again Later";
      //        // console.log("Caught :::::::::::::::", e.message);
      //      })
      // }
      // else
      // {
      //   parent.show= false;
      //   parent.$bvModal.show('failureModal2');
      // }
      // })
      axios.post(parent.$urlCommon + "/api/web/updateTdsDetails", tdsDataToSend).then(function (response) {

        // console.log(response.data);



        var msg = response.data.msg;

        if (msg == "00") {

          axios.post(parent.$urlArms + "/RestAPI/OnlinePortal/updateTdsConsDetails?consNo=" + consNo + "&tanNo=" + tdsDataToSend.tan_no + "&billNo=" + parent.billNoSelected + "&tdsAmountDeducted=" + tdsDataToSend.tds_deducted + "&challanNo=" + tdsDataToSend.challan_no + "&challanDt=" + tdsDataToSend.challan_date + "&challanAmt=" + tdsDataToSend.challan_amt + "&authorisedPerson=" + parent.authName, formData, {
            headers: {
              'Content-Type': 'multipart/form-data'
            }
          }).then(function (response) {
            parent.show = false;
            //   parent.show1= false;
            var msg = response.data.status;
            if (msg == "Success") {
              parent.$bvModal.show('successModal2');
            }
            else {
              parent.show = false;
              parent.$bvModal.show('failureModal2');
            }
          }).catch((e) => {
            parent.show = false;
            parent.$bvModal.show('model');
            document.getElementById("modalMsg").innerHTML = "Sorry, Please Try Again Later";
            // console.log("Caught :::::::::::::::", e.message);
          })
        }
        else {
          parent.$bvModal.show('failureModal2');
        }
      })
        .catch((e) => {
          parent.show = false;
          parent.$bvModal.show('model');
          document.getElementById("modalMsg").innerHTML = "Sorry, Please Try Again Later";
          // console.log("Caught :::::::::::::::", e.message);
        })

    }

  },
  mounted() {
    axios.post(this.$urlCommon + "/api/web/getCaptcha").then(function (response) {
      //// console.log(response.data);
      document.getElementById("captcha").src = "data:image/png;base64," + response.data;
      document.getElementById("captcha2").src = "data:image/png;base64," + response.data;

    })

    document.getElementById('mobNo').addEventListener('keydown', function (event) {
      event.preventDefault();
    });

    document.getElementById('mobNo').readOnly = true;

    document.getElementById('email').addEventListener('keydown', function (event) {
      event.preventDefault();
    });

    document.getElementById('email').readOnly = true;

  }
}
</script>

<style scoped="true">
.label {
  font-weight: 600;
}

.data {
  font-weight: 500;
  color: #bf360c;
  font-size: 1.1rem;
}

.declaration {
  color: #263238;
  font-weight: 600;
}

.userDetails {
  visibility: hidden;
  opacity: 0;
  transition: visibility 0s, opacity 0.5s linear;
}

.showUserDetails {
  visibility: visible;
  opacity: 1;
}

.updateMobilestyle {
  padding: 5px;
  border-radius: 5px;
  color: red;
  font-weight: bold;
  background-color: orange;
  animation: flicker 2s infinite;
}

@keyframes flicker {

  0%,
  50%,
  100% {
    opacity: 1;
  }

  25%,
  75% {
    opacity: 0.6;
  }
}

.updateEmailstyle {
  padding: 5px;
  border-radius: 5px;
  margin-left: 10px;
  color: orange;
  font-weight: bold;
}

hr {
  margin-top: 5px;
  margin-bottom: 5px;
}

.go:focus {
  box-shadow: none;
}

.modalFont {
  width: 100px;
  display: block;
  margin: 40px auto 0;
}

.path {
  stroke-dasharray: 1000;
  stroke-dashoffset: 0;
}

.path.circle {
  -webkit-animation: dash 0.9s ease-in-out;
  animation: dash 0.9s ease-in-out;
}

.path.line {
  stroke-dashoffset: 1000;
  -webkit-animation: dash 0.9s 0.35s ease-in-out forwards;
  animation: dash 0.9s 0.35s ease-in-out forwards;
}

.path.check {
  stroke-dashoffset: -100;
  -webkit-animation: dash-check 0.9s 0.35s ease-in-out forwards;
  animation: dash-check 0.9s 0.35s ease-in-out forwards;
}

p {
  text-align: center;
  margin: 20px 0 60px;
  font-size: 1.25em;
}

p.success {
  color: #73AF55;
}

p.error {
  color: #D06079;
}

.hideDiv {
  visibility: hidden;
  opacity: 0;
  transition: visibility 0s, opacity 0.5s linear;

  padding: 0rem;
}

.showDiv {
  visibility: visible;
  opacity: 1;
}

@-webkit-keyframes dash {
  0% {
    stroke-dashoffset: 1000;
  }

  100% {
    stroke-dashoffset: 0;
  }
}

@keyframes dash {
  0% {
    stroke-dashoffset: 1000;
  }

  100% {
    stroke-dashoffset: 0;
  }
}

@-webkit-keyframes dash-check {
  0% {
    stroke-dashoffset: -100;
  }

  100% {
    stroke-dashoffset: 900;
  }
}

@keyframes dash-check {
  0% {
    stroke-dashoffset: -100;
  }

  100% {
    stroke-dashoffset: 900;
  }
}

.headerF {
  display: block;
}

.headerM {
  display: none;
}

@media (max-width: 768px) {
  .headerF {
    display: none;
  }

  .headerM {
    display: block;
  }
}

@media (max-width: 768px) {
  .headerF {
    display: none;
  }

  .headerM {
    display: block;
  }

  .marginRight30px {
    margin-right: 30px !important;
  }
}

@media (max-width: 576px) {
  .marginTop10px {
    margin-top: 10px !important;
  }
}
</style>
